
import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CloseIcon from "@mui/icons-material/Close";
import RestoOutlineIcon from "@mui/icons-material/FoodBankOutlined";
import StoreIcon from "@mui/icons-material/Store";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import Sett from "@mui/icons-material/Settings";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import BBQImage from "../../../../elements/bbq-image";


const Sidebar = () => {
  const navigate = useNavigate();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    closeMobileSidebar();
    navigate("/");
  };

  const getNavClass = ({ isActive }) => (isActive ? "active-link" : "");

  return (
    <>
      <button
        type="button"
        className={`admin-sidebar-toggle ${isMobileSidebarOpen ? "is-open" : ""}`}
        aria-label={isMobileSidebarOpen ? "Close menu" : "Open menu"}
        aria-expanded={isMobileSidebarOpen}
        onClick={() => setIsMobileSidebarOpen((isOpen) => !isOpen)}
      >
        {isMobileSidebarOpen ? <CloseIcon /> : <MenuIcon />}
      </button>

      {isMobileSidebarOpen && (
        <button
          type="button"
          className="admin-sidebar-backdrop"
          aria-label="Close menu"
          onClick={closeMobileSidebar}
        />
      )}

      <div className={`sidebar ${isMobileSidebarOpen ? "open" : ""}`}>
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }} onClick={closeMobileSidebar}>
          <BBQImage
            src="images/BBQ_LOGO.png"
            alt="#"
            className="header-logo-login cursor-pointer"
          />
        </Link>
      </div>

      <hr />

      <div className="center">
        <ul>
          <p className="title">MAIN</p>

          <NavLink
            to="/config"
            end
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </NavLink>

          <NavLink
            to="/config/reports"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <AssessmentIcon className="icon" />
              <span>Reports</span>
            </li>
          </NavLink>

          <p className="title">CONFIGURATION</p>

          <NavLink
            to="/config/restaurants"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <RestoOutlineIcon className="icon" />
              <span>Restaurants/Hotels/Retails</span>
            </li>
          </NavLink>

          <NavLink
            to="/config/products"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <StoreIcon className="icon" />
              <span>Products</span>
            </li>
          </NavLink>

          <p className="title">USER</p>

          <NavLink
            to="/config/settings/general"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <Sett className="icon" />
              <span>General Settings</span>
            </li>
          </NavLink>

          <NavLink
            to="/config/profile"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <AccountCircleOutlinedIcon className="icon" />
              <span>Profile</span>
            </li>
          </NavLink>

          <NavLink
            to="/config/accounting"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <StoreIcon className="icon" />
              <span>Accounting & Renewal</span>
            </li>
          </NavLink>

          <NavLink
            to="/config/help-and-support"
            className={getNavClass}
            style={{ textDecoration: "none" }}
            onClick={closeMobileSidebar}
          >
            <li>
              <StoreIcon className="icon" />
              <span>Help And Support</span>
            </li>
          </NavLink>

          <li onClick={handleLogout}>
            <ExitToAppIcon className="icon" />
            <span>Logout</span>
          </li>
        </ul>
      </div>
      </div>
    </>
  );
};

export default Sidebar;
